<template>
<div>
    <div class="important pa-2">
        {{ $t('distribuiton.booking.rate_plans') }}
    </div>
    <v-card v-for="rate in rate_plans" :key="'rate_'+rate.id" class="pa-2 mx-md-2 my-2">
        <v-row align="center" no-gutters>
            <v-col sm="6" cols="12" class="py-0 regular">
                <span>{{ rate.name }}</span>
                <span class="detail">({{ rate.id }})</span>
            </v-col>
            <v-col sm="6" cols="12" class="py-0">
                <v-select :items="computedItems" v-model="rate.partner.id" :menu-props="{'content-class':'room-selection'}" item-text="name" item-value="id" label="Partner rate" clearable @input="setRatePlanName(rate),isDirty()">
                    <template v-slot:selection="data">
                        <div class="text-truncate regular" style="max-width: 250px">
                            {{data.item.name}}
                        </div>
                    </template>
                    <template v-slot:item="data">
                        <div>
                            <span>{{ data.item.name }}</span>
                            <span class="detail">({{ data.item.id }})</span>
                        </div>
                    </template>
                </v-select>
            </v-col>
        </v-row>
    </v-card>

</div>
</template>

<script>
import {
    mapActions
} from 'vuex';

export default {
    name: `channel-manager-tab`,

    props: {
        system_id: [Number, String],
        partner_id: [Number, String],
        integration_id: [Number, String],
    },
    components: {},

    data() {
        return {
            dirty: false,
            original_map_rate: [],
            rate_plans: [],
            rate_plans_booking: [],
            rates_mapped_ids: [],
            //dialogs
            delete_integration: false,
            delete_map: false,
            id_map_delete: null,
            index_map_delete: null,
        }
    },

    watch: {
        integration_id() {
            this.getRateMapping();
        }
    },

    computed: {
        computedItems() {
            return this.rate_plans_booking.map(item => {
                return {
                    name: item.name,
                    id: item.id,
                    disabled: this.computedIds.includes(item.id)
                }
            })
        },
        computedIds() {
            return this.rate_plans.map(item => {
                if(item.partner.id) {
                    return item.partner.id
                }

            })
        },
    },

    created() {
        this.getRateMapping();
    },

    methods: {
        ...mapActions('alert', ['success', 'error']),

        getRateMapping() {
            this.getRatePlans()
                .then(() => this.getMappingsRates())
                .then(() => this.getRatePlansBooking())
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {});
        },

        getRatePlans() {
            if(!this.system_id) {
                return;
            }

            // prepare stamp & save current_stamp
            let stamp = Date.now();
            this.current_stamp = stamp;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/rate-plans";

            // setup query params
            let params = {
                params: {
                    hotel_id: this.system_id,
                    stamp: stamp,
                }
            };

            return this.$axios.get(endpoint, params)
                .then(response => {
                    response.data.data.forEach(function (rate) {
                        rate.partner = {
                            id: null,
                            name: null
                        }
                        this.rate_plans.push(rate);
                    }.bind(this))

                    return new Promise(function (resolve, reject) {
                        resolve(response.data);
                    });

                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {});
        },

        getMappingsRates() {
            if(!this.integration_id) {
                return
            }
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/cm/rate-plan-mappings";

            let params = {
                params: {
                    integration_id: this.integration_id,
                }
            };
            return this.$axios.get(endpoint, params)
                .then(response => {
                    response.data.data.forEach(function (rate_maped) {
                        this.rate_plans.forEach(function (rate) {
                            if(rate.id == rate_maped.system_id) {
                                rate.partner.id = rate_maped.partner_id.toString();
                                rate.partner.name = rate_maped.partner_name;
                            }
                        }.bind(this));
                    }.bind(this))

                    this.original_map_rate = response.data.data;

                    return new Promise(function (resolve, reject) {
                        resolve(response.data);
                    });
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {});
        },

        getRatePlansBooking() {
            if(!this.partner_id) {
                return;
            }

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/cm/booking/rate-plans";

            // prepare stamp & save current_stamp
            let stamp = Date.now();
            this.current_stamp = stamp;

            // setup query params
            let params = {
                params: {
                    partner_hotel_id: this.partner_id,
                }
            };

            return this.$axios.get(endpoint, params)
                .then(response => {
                    this.rate_plans_booking = response.data;
                    return new Promise(function (resolve, reject) {
                        resolve(response.data);
                    });
                })
                .catch(error => {
                    this.error('Ooops, something gone wrong');
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        setRatePlanName(rate) {
            if(rate.partner.id) {
                rate.partner.name = this.rate_plans_booking.filter(item => item.id == rate.partner.id)[0].name;
            }
        },

        async saveItem() {
            this.$emit('loading');
            let ids_maps_delete = [];
            let new_maps = [];
            this.rate_plans.forEach(function (rate, index) {
                let old_map = false;
                this.original_map_rate.forEach(function (map) {
                    if(map.system_id == rate.id) {
                        old_map = true;
                        if(map.partner_id != rate.partner.id) {
                            ids_maps_delete.push(map.id);
                            if(rate.partner.id) {
                                new_maps.push(rate);
                            }
                        }
                    }
                })
                if(!old_map && rate.partner.id) {
                    new_maps.push(rate);
                }
            }.bind(this))

            await Promise.all(ids_maps_delete.map(async (id) => {
                await this.deleteMap(id);
            }))


            await Promise.all(new_maps.map(async (new_map) => {
                let item = {
                    integration_id: this.integration_id,
                    partner_rate_plan: {
                        id: new_map.partner.id,
                        name: new_map.partner.name,
                    },
                    system_rate_plan: {
                        id: new_map.id,
                        name: new_map.name,
                    },
                }
                await this.createMap(item);
            }))
            this.$emit('loading');
        },

        isDirty() {
            this.$parent.$emit("isDirty");
        },

        async createMap(item) {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/cm/rate-plan-mappings";

            return this.$axios.post(endpoint, item)
                .then(response => {
                    return new Promise(function (resolve, reject) {
                        resolve(response);
                    });
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {});
        },

        async deleteMap(id) {

            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/cm/rate-plan-mappings/";
            return this.$axios.delete(endpoint + id)
                .then(response => {
                    return new Promise(function (resolve, reject) {
                        resolve(response);
                    });
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {});
        }
    },
}
</script>
<style lang="stylus">
.room-selection
    .v-list__tile--active
        background-color: WhiteSmoke
</style>
